
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T2010TeacherBasicService.M00501_doBrowse_AtDataTable', input: {}},
    initDropdown: { api: 'T2010TeacherBasicService.M00501_init_dropDown', input: {}},
    getOneWeekTeacherCountsList: { api: 'T3010ScheduleService.getOneWeekTeacherCounts', input: {}},
  },
}

const module = {
  state: {
    PageConst,

    oneWeekTeacherCountsList: [],
    dropdownData: {
      timeLimit: [],
      joinStatus: [],
      student: [],
      teacher: [],
      advisor: [],
    }
  },

  getters: {},

  mutations: {},

  actions: {
    async init ({ state, commit }, payload) {
      const scheduleDate = state.searchInfo.schedule_date
      const res = await $this.$api.postData({
        data: {
          initDropdown: { api: PageConst.ACTION.initDropdown.api, input: { schedule_date : scheduleDate } },
          oneWeekTeacherCountsList: { api: PageConst.ACTION.getOneWeekTeacherCountsList.api, input: { schedule_date : scheduleDate } },
        }
      })
      commit('setState', {
        oneWeekTeacherCountsList: res.oneWeekTeacherCountsList.output,
        dropdownData: {
          timeLimit: res.initDropdown.output.timeLimit,
          joinStatus: res.initDropdown.output.joinStatus,
          student: res.initDropdown.output.student,
          teacher: res.initDropdown.output.teacher,
          advisor: res.initDropdown.output.advisor
        }
      })
    },
    async setMeetingInSchedule ({ state }, payload) {
      const res = await $this.$api.postData({
        data: [
          { api: 'T0020BatchLogService.setMeetingInSchedule', input: payload },
        ]
      })
      return res[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
